import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import moment from 'moment';
import { push } from 'connected-react-router';

import Page1 from './FormPages/Page1';
import Page2 from './FormPages/Page2';
import ClientInfo from './FormPages/ClientInfo';
import AllResults from './FormPages/AllResults';
import Exists from './FormPages/Exists';
import ChangePage from '../../Actions/Register/changePage';

import api from '../../lib/api';
import { processLogin } from '../../Actions/Dashboard/login';
import { checkRegistration } from '../../Actions/Password/register';

class RegForm extends React.Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.submitValues = this.submitValues.bind(this);
    this.dashboard = this.dashboard.bind(this);
    this.sorryPage = this.sorryPage.bind(this);
    this.checkReg = this.checkReg.bind(this);
    this.checkLoggedIn = this.checkLoggedIn.bind(this);
  }

  nextPage() {
    let page = this.props.page + 1;
    if (this.props.page === 11 && this.props.units_per_week < 1) {
      page = this.props.page + 2;
    }
    if (this.props.page === 8 && this.props.alcohol_more_question.toLowerCase() === 'no') {
      page = this.props.page + 2;
    }
    if (this.props.page === 8 && this.props.auditc_score <= 5) {
      page = this.props.page + 2;
    }

    this.props.dispatch(ChangePage(page));
  }

  previousPage() {
    let page = this.props.page - 1;
    if (this.props.page === 10 && (this.props.units_per_week < 1 || this.props.auditc_score <= 5 || this.props.alcohol_more_question.toLowerCase() === 'no')) {
      page = this.props.page - 2;
    }
    if (this.props.page === 11) {
      this.props.dispatch(ChangePage(3));
    } else {
      this.props.dispatch(ChangePage(page));
    }
  }

  sorryPage() {
    window.location = '/sorry';
  }

  submitValues(values) {
    const dobDate = moment(values.client.dob);
    const newVals = values;
    newVals.client.dob = dobDate.format('YYYY-MM-DD');

    // set HDYHAU values for smoking cessation
    newVals.client.how_a = 8;
    newVals.client.how_b = 'Dorset County Hospital';
    newVals.client.how_c = 'Lung condition (PILOT)';
    newVals.client.smoking = 'Yes';

    api.postRegistration(newVals, () => {
      if(dataLayer) dataLayer.push({ event: 'RegSuccess' }); // eslint-disable-line
      this.props.dispatch(processLogin({
        email: values.client.email,
        pw: values.client.password,
        dob: newVals.client.dob,
        noredirect: true,
      }));
    });
  }

  checkLoggedIn(values) {
    const dobDate = moment(values.client.dob);
    const data = {
      email: values.client.email,
      dob: dobDate.format('YYYY-MM-DD'),
      values: values,
    };
    api.sendPost(`/clients/check-client`, data, (error, response) => {
      if (error) return console.error(error);
      if (response.data.exists === true) {
        return;
      } else {
        this.submitValues(data.values)
      }
    });

  }

  checkReg(values) {
    const dobDate = moment(values.client.dob);
    const data = {
      email: values.client.email,
      dob: dobDate.format('YYYY-MM-DD'),
    };
    this.props.dispatch(checkRegistration(data));
  }

  dashboard() {
    this.props.dispatch(push('/dashboard'));
    window.location = '/dashboard';
  }

  render() {
    const { page } = this.props;

    return (
      <div className="wrap">
        <div className="ga-script">
            <script>
                ga('set', 'page', '/pilot-{page}.html');
                ga('send', 'pageview');
            </script>
        </div>

        {page === 1 && <Page1 onSubmit={this.nextPage} />}
        {page === 2 && (
          <Page2
            onSubmit={this.nextPage}
            onNoConsent={this.sorryPage}
          />
        )}
        {page === 3 && (
          <ClientInfo
            previousPage={this.previousPage}
            onSubmit={this.checkReg}
            smoking={this.props.smoking}
            pregnant={this.props.pregnant}
          />
        )}
        {page === 4 && <AllResults
          previousPage={this.previousPage}
          pregnant={this.props.pregnant}
          score={this.props.auditc_score}
          smoking={this.props.smoking}
          smokingtype={this.props.smokingType}
          smokingamount={this.props.smokingAmount}
          dispatch={this.props.dispatch}
          onSubmit={this.checkLoggedIn}
          dashboard={this.dashboard}
        />}

        {page === 5 && <Exists previousPage={this.previousPage} />}
      </div>
    );
  }
}

const selector = formValueSelector('registrationPilot');

RegForm.propTypes = {
  page: PropTypes.number.isRequired,
  smoking: PropTypes.string.isRequired,
  smokingType: PropTypes.string.isRequired,
  smokingAmount: PropTypes.string.isRequired,
  pregnant: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(state => ({
  smoking: selector(state, 'client[smoking]') || '',
  smokingType: selector(state, 'client[smoking_type_id]') || '',
  smokingAmount: selector(state, 'client[smoking_quantity]') || '0',
  pregnant: selector(state, 'client[activity_pregnant]') || 'No',
  page: state.registrationPage,
}))(RegForm);



// WEBPACK FOOTER //
// ./src/Components/PilotRegister/index.jsx